import { Configuration } from '@jucy/rentals-api-client/rentals-api-v3/runtime';

export const rentalsApiConfig = () =>
    new Configuration({
        basePath: globalThis.jucyConfig.rentalsApiBaseUrl,
        middleware: globalThis.jucyConfig.rentalsApiMiddleware,
    });
